/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import FeatherIcon from "components/FeatherIcon";

interface BookingLoginBuyUpsellsCardProps {
    onClick: () => {};
}

const BookingLoginBuyUpsellsCard = (props: BookingLoginBuyUpsellsCardProps) => {
    const {t} = useTranslation();

    return (
        <button
            className={clsx(
                // "BookingLoginBuyUpsellsCard cursor-pointer w-full grid grid-cols-[1fr,32px] md:grid-cols-[1fr,48px] justify-between gap-x-2 py-3 md:py-[18px] px-4 md:px-[30px] shadow-md rounded-[10px] overflow-hidden !bg-black "
                // "BookingLoginBuyUpsellsCard cursor-pointer w-full grid grid-cols-[1fr,32px] md:grid-cols-[1fr,48px] justify-between gap-x-2 py-3 md:py-[18px] px-4 md:px-[30px] shadow-md rounded-[10px] overflow-hidden !bg-black "
                "BookingLoginBuyUpsellsCard cursor-pointer w-full grid gap-x-2 py-3 md:py-[18px] px-4 md:px-[30px] shadow-md rounded-[10px] overflow-hidden !bg-black",
                // mobile: 2 stĺpce (obsah + ikona), h4 pod nimi na celú šírku
                "grid-cols-[1fr,32px]",
                // md+: 2 stĺpce (ľavý obsah, pravá ikona)
                "md:grid-cols-[1fr,48px]",
                // riadky automaticky, na md použijeme dve riadky pre ľavý stĺpec
                "auto-rows-min",
                "content-center",
            )}
            type={"button"}
            title={t("Exclusive Extras for your booking – only online!")}
            aria-labelledby={"ReservationLoginBuyUpsells"}
            aria-label={t("Buy additional extras")}
            onClick={props.onClick}
        >
            <h3
                id={"ReservationLoginBuyUpsells"}
                // className={"col-start-1 col-end-2 font-zuume text-left text-xl md:text-4xl leading-[1] mb-[10px] font-bold text-arbo-yellow"}
                className={
                    // mobile: v ľavom stĺpci, prvý v poradí
                    // md+: v ľavom stĺpci, prvý riadok
                    "order-1 col-start-1 col-end-2 md:col-start-1 md:col-end-2 md:row-start-1 font-zuume text-left text-xl md:text-4xl leading-[1] mb-[10px] font-bold text-arbo-yellow"
                }
            >
                {t("Buy additional extras")}?
            </h3>
            <h4
                // className={"row-start-2 row-end-3 text-left col-start-1 col-end-3 font-poppins text-xxs md:text-xs font-semibold text-white"}
                className={
                    // mobile: ide až pod h3 a ikonu, cez celú šírku
                    // md+: v ľavom stĺpci, druhý riadok
                    "order-3 col-start-1 col-end-3 md:order-3 md:col-start-1 md:col-end-2 md:row-start-2 text-left font-poppins text-xxs md:text-xs font-semibold text-white"
                }
            >
                {t("Exclusive Extras for your booking – only online!")}
            </h4>
            <div
                // className={"row-start-1 col-start-2 col-end-3 flex flex-row items-start md:items-center h-full shrink-0"}
                className={clsx(
                    // mobile: zarovno h3 vpravo
                    // md+: v pravom stĺpci, cez oba riadky
                    "order-2 row-start-1 col-start-2 col-end-3 md:order-2 md:row-[1_/span_2] md:col-start-2 md:col-end-3 flex flex-row items-start md:items-center h-full shrink-0",
                    "items-center"
                )}
            >
                <FeatherIcon name={"shopping-bag"} className={"size-[30px] md:size-[50px] text-white shrink-0"} strokeWidth={1} />
                {/*<ShoppingBagIcon className={"size-[30px] md:size-[50px] stroke-2 text-white shrink-0"} />*/}
            </div>
        </button>
    );
};

export default BookingLoginBuyUpsellsCard;
